// extracted by mini-css-extract-plugin
export default {"footerActions":"footer-actions_footerActions__fahJt"};